import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HolidaysService {
  easter: { [key: string]: Date } = {
    '2010': new Date(2010, 3, 4),
    '2011': new Date(2011, 3, 24),
    '2012': new Date(2012, 3, 8),
    '2013': new Date(2013, 2, 31),
    '2014': new Date(2014, 3, 20),
    '2015': new Date(2015, 3, 5),
    '2016': new Date(2016, 2, 27),
    '2017': new Date(2017, 3, 16),
    '2018': new Date(2018, 3, 1),
    '2019': new Date(2019, 3, 21),
    '2020': new Date(2020, 3, 12),
    '2021': new Date(2021, 3, 4),
    '2022': new Date(2022, 3, 17),
    '2023': new Date(2023, 3, 9),
    '2024': new Date(2024, 2, 31),
    '2025': new Date(2025, 3, 20),
    '2026': new Date(2026, 3, 5),
    '2027': new Date(2027, 2, 28),
    '2028': new Date(2028, 3, 16),
    '2029': new Date(2029, 3, 1),
    '2030': new Date(2030, 3, 21),
    '2031': new Date(2031, 3, 13),
    '2032': new Date(2032, 2, 28),
    '2033': new Date(2033, 3, 17),
    '2034': new Date(2034, 3, 9),
    '2035': new Date(2035, 2, 25),
    '2036': new Date(2036, 3, 13),
    '2037': new Date(2037, 3, 5),
    '2038': new Date(2038, 3, 25),
    '2039': new Date(2039, 3, 10),
    '2040': new Date(2040, 3, 1),
  };
  constHolidays: { day: number; month: number }[] = [
    {
      day: 1,
      month: 0,
    },
    {
      day: 6,
      month: 0,
    },
    {
      day: 1,
      month: 4,
    },
    {
      day: 3,
      month: 4,
    },
    {
      day: 15,
      month: 7,
    },
    {
      day: 1,
      month: 10,
    },
    {
      day: 11,
      month: 10,
    },
    {
      day: 25,
      month: 11,
    },
    {
      day: 26,
      month: 11,
    },
  ];
  constructor() {}

  private isSaturday(value: Date) {
    return value.getDay() == 6;
  }

  private isSunday(value: Date) {
    return value.getDay() == 0;
  }

  private isConstHoliday(value: Date): boolean {
    return !!this.constHolidays.find(
      (holiday) =>
        value.getDate() == holiday.day && value.getMonth() == holiday.month
    );
  }

  private isMobileHoliday(value: Date): boolean {
    const easterThisYear = this.easter[value.getFullYear()];
    return (
      this.isSecondDayOfEaster(easterThisYear, value) ||
      this.isCorpusChristi(easterThisYear, value)
    );
    //Dont check first day of Easter and Pentecost because it is sunday anyway
  }

  private isCorpusChristi(easterThisYear: Date, value: Date): boolean {
    return easterThisYear.getTime() + 5184000000 == value.getTime();
  }

  private isSecondDayOfEaster(easterThisYear: Date, value: Date): boolean {
    return easterThisYear.getTime() + 86400000 == value.getTime();
  }

  isHolidayOrWeekend(value: Date): boolean {
    if (this.isSaturday(value)) { return true; }
    return this.isHoliday(value);
  }

  isHoliday(value: Date): boolean {
    return this.isSunday(value) ||
      this.isConstHoliday(value) ||
      this.isMobileHoliday(value);
  }
}
